import { dateRangeValidator, DATE_RANGE_MESSAGE } from '../../../core/utils/date-range.validator';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import * as ClientConstants from '../../../core/constants/client.constants';
import { ClientsService } from '../../../core/services/clients/clients.service';
import { CodesService } from '../../../core/services/codes/codes.service';
import { ClientsTableComponent } from '../../clients-table/clients-table.component';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFilePlus } from '@fortawesome/pro-light-svg-icons';
import { IbanFormatPipe } from '../../../core/pipes/iban-format.pipe';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoAuditDirective } from '../../../shared/directives/auto-audit.directive';
import { parseDateOnlyToLocal, toDateOnlyPayload } from '../../../core/utils/date-only.util';
import { AuditService } from '../../../core/services/audit/audit.service';
import { LatestPerFieldMap } from '../../../core/models/audit.model';

@Component({
  selector: 'app-activities-form',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    InputTextModule,
    DropdownModule,
    AccordionModule,
    CheckboxModule,
    ClientsTableComponent,
    CommonModule,
    FileUploadModule,
    ButtonModule,
    FontAwesomeModule,
    IbanFormatPipe,
    InputTextareaModule,
    AutoAuditDirective,
  ],
  templateUrl: './activities-form.component.html',
  styleUrl: './activities-form.component.scss'
})
export class ActivitiesFormComponent implements OnChanges {

  public clientConstants = ClientConstants;
  faFilePlus = faFilePlus;

  fieldAuditData: LatestPerFieldMap = {};

  configActivitiesTable: any = {
    headers: [
      { name: 'Tipo', key: 'type' },
      { name: 'CNAE', key: 'CNAECode' },
      { name: 'IAE', key: 'IAECode' },
      { name: 'Fecha inicio', key: 'startDate' },
      { name: 'Fecha de baja', key: 'endDate' },
      { name: 'Principal', key: 'isPrincipal' },
      { name: 'Con local', key: 'withLocal' },
      { name: 'Con centro de trabajo', key: 'withWorkCenter' },
      { name: 'Exento de IAE', key: 'iaeExcemption' },
      { name: 'Exención por inicio', key: 'iaeExcemptionByStartUp' },
      { name: 'Exención por cifra de negocios', key: 'iaeExcemptionByTurnover' },
      { name: 'Observaciones', key: 'observations' },
      { name: '', key: 'delete' }
    ],
    data: [],
    isActivities: true
  };
  activitiesForm: FormGroup;
  activityForm: FormGroup;

  isActivityModalVisible = false;
  isDeleteActivityModalVisible = false;
  editingActivityIndex: number | undefined = undefined;
  deleteActivityIndex: number;

  iaeCodes: any[] = [];
  iaeCodesGrouped: any[] = [];
  iaeCodesFiltered: any[] = [];
  cnaeCodes: any[] = [];
  bankAccounts: any[] = [];

  addresses: any[] = [];

  companyLogo: File = null;
  companyLogoPreview: string = null;
  companySignature: File = null;
  companySignaturePreview: string = null;

  @Input() clientId: any;
  @Input() clientType: any;
  @Input() snapshotData: any[] | null = null;
  @Output() formIsDirty = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private clientsService: ClientsService,
    private codesService: CodesService,
    private auditService: AuditService,
  ) {
    this.activitiesForm = this.fb.group({
      activities: this.fb.array([])
    });

    this.activityForm = this.fb.group({
      id: [],
      type: [''],
      startDate: [null, Validators.required],
      endDate: [null],
      CNAECode: [''],
      IAECode: [''],
      isPrincipal: [false],
      withLocal: [false],
      town: [''],
      province: [''],
      totalBuilt: [null],
      totalUseful: [null],
      m2WithoutReduction: [null],
      m2Uncovered: [null],
      m2Teaching: [null],
      m2Store: [null],
      m2CoveredParking: [null],
      withWorkCenter: [false],
      socialSecurityCode: [''],
      workCenterCode: [''],
      internshipCode: [''],
      laboralAuthorityNumber: [''],
      mutua: [''],
      colectiveAgreement: [''],
      srpl: [''],
      agreementInsurance: [''],
      legalRepresentation: [false],
      legalRepresentationType: [''],
      tgssNumber: [''],
      healthComittee: [false],
      equalityPlan: [false],
      lismiObligations: [false],
      lgtbiProtocol: [false],
      complaintsChannel: [false],
      sexualProtocol: [false],
      redSystemNumber: [''],
      socialSecurityRegime: [''],
      companyLogo: [''],
      companySignature: [''],
      payrollIban: [''],
      socialSecurityIban: [''],
      accidentsMutua: [''],
      collectiveAgreementApplicable: [''],
      numWorkers: [null],
      powerKw: [null],
      numVehicles: [null],
      vehicleTypes: [''],
      numMachines: [null],
      machineryTypes: [''],
      shopWindows: [''],
      quotaClass: [''],
      iaeExcemption: [null],
      iaeExcemptionByStartUp: [false],
      iaeExcemptionByTurnover: [false],
      iaeExcemptionStartDate: [null],
      iaeExcemptionEndDate: [null],
      iaeExcemptionTurnoverStartDate: [null],
      iaeExcemptionTurnoverEndDate: [null],
      clientAddress: [null],
      client: [null],
      observations: [''],
    });

    this.activityForm.addValidators(dateRangeValidator([
      ['startDate', 'endDate'],
      ['iaeExcemptionStartDate', 'iaeExcemptionEndDate'],
      ['iaeExcemptionTurnoverStartDate', 'iaeExcemptionTurnoverEndDate'],
    ]));
    // Sincronizar fechas de exención con fecha de alta
    this.activityForm.get('startDate')?.valueChanges.subscribe(startDate => {
      if (startDate) {
        if (this.activityForm.get('iaeExcemptionByStartUp')?.value) {
          this.activityForm.get('iaeExcemptionStartDate')?.setValue(startDate, { emitEvent: false });
        }
        if (this.activityForm.get('iaeExcemptionByTurnover')?.value) {
          this.activityForm.get('iaeExcemptionTurnoverStartDate')?.setValue(startDate, { emitEvent: false });
        }
      }
    });

    // Sincronizar fecha de inicio de exención por inicio con startDate
    this.activityForm.get('iaeExcemptionByStartUp')?.valueChanges.subscribe(checked => {
      if (checked && this.activityForm.get('startDate')?.value) {
        this.activityForm.get('iaeExcemptionStartDate')?.setValue(this.activityForm.get('startDate')?.value, { emitEvent: false });
      }
    });

    // Sincronizar fecha de inicio de exención por cifra con startDate
    this.activityForm.get('iaeExcemptionByTurnover')?.valueChanges.subscribe(checked => {
      if (checked && this.activityForm.get('startDate')?.value) {
        this.activityForm.get('iaeExcemptionTurnoverStartDate')?.setValue(this.activityForm.get('startDate')?.value, { emitEvent: false });
      }
    });

    this.activitiesForm.valueChanges.subscribe(() => {
      if (this.activitiesForm.dirty) {
        this.formIsDirty.emit(true);
      }
    });
  }

  async ngOnInit() {
    if (!this.snapshotData) {
      await this.getData();
    } else {
      await this.loadFieldAuditData();
    }
    this.iaeCodes = await this.codesService.getIaeCodes();
    this.cnaeCodes = await this.codesService.getCnaeCodes();

    // Agrupar códigos IAE por tipo
    this.groupIaeCodes();
    this.iaeCodesFiltered = this.iaeCodesGrouped;

    // Escuchar cambios en el tipo de actividad para filtrar códigos IAE
    this.activityForm.get('type')?.valueChanges.subscribe(type => {
      this.filterIaeCodesByType(type);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['snapshotData']) {
      if (this.snapshotData) {
        this.configActivitiesTable = { ...this.configActivitiesTable, data: [...this.snapshotData] };
        void this.loadFieldAuditData();
      } else if (!changes['snapshotData'].firstChange) {
        void this.getData();
      }
    }
  }

  groupIaeCodes() {

    // Definir orden de tipos
    const typeOrder = ['EMPRESARIAL', 'PROFESSIONAL', 'ARTISTIC', 'OTROS'];

    // Agrupar por tipo
    const grouped = new Map<string, any[]>();

    this.iaeCodes.forEach(code => {
      let type = (code.type || 'OTROS').trim();

      // Normalizar tipos variados al estándar (case-sensitive para coincidir con BD)
      if (type === 'Empresarial' || type === 'EMPRESARIAL') {
        type = 'EMPRESARIAL';
      } else if (type === 'Profesional' || type === 'PROFESSIONAL') {
        type = 'PROFESSIONAL';
      } else if (type === 'Artistica' || type === 'Artística' || type === 'Artisticos' || type === 'Artísticos' || type === 'ARTISTIC') {
        type = 'ARTISTIC';
      } else if (type === 'Otros' || type === 'OTROS' || type === '') {
        type = 'OTROS';
      } else if (!typeOrder.includes(type)) {
        console.warn('Unknown type found:', type);
        type = 'OTROS';
      }

      if (!grouped.has(type)) {
        grouped.set(type, []);
      }
      grouped.get(type)?.push(code);
    });


    // Ordenar códigos dentro de cada grupo
    grouped.forEach((codes, type) => {
      codes.sort((a, b) => a.code.localeCompare(b.code));
    });

    // Convertir a formato para p-dropdown con grupos, respetando el orden
    this.iaeCodesGrouped = typeOrder
      .filter(type => grouped.has(type) && grouped.get(type)!.length > 0)
      .map(type => ({
        label: this.getActivityTypeLabel(type),
        value: type,
        items: grouped.get(type) || []
      }));

  }

  filterIaeCodesByType(type: string) {
    if (!type) {
      this.iaeCodesFiltered = this.iaeCodesGrouped;
    } else {
      this.iaeCodesFiltered = this.iaeCodesGrouped.filter(group => group.value === type);
    }
  }

  getActivityTypeLabel(type: string): string {
    const activityType = ClientConstants.ACTIVITY_TYPES.find(t => t.value === type);
    return activityType ? activityType.label : type;
  }

  getSelectedIaeCode(codeValue: any) {
    if (!codeValue) return null;

    // Si es un objeto, ya tenemos el código completo
    if (typeof codeValue === 'object' && codeValue.code) {
      return codeValue;
    }

    // Si es un string, buscar en la lista
    if (typeof codeValue === 'string') {
      return this.iaeCodes.find(c => c.code === codeValue);
    }

    return null;
  }

  async getData() {
    if (this.clientId) {
      this.bankAccounts = (await this.clientsService.getClientBankAccounts(this.clientId))
        .filter((account: any) => account.endDate === null);
      const addressesData = await this.clientsService.getClientAddresses(this.clientId);
      addressesData.forEach(address => {
        address.startDate = address.startDate ? new Date(address.startDate) : null;
        address.endDate = address.endDate ? new Date(address.endDate) : null;
        this.addresses.push(this.fb.group({
          type: [address.type],
          startDate: [address.startDate, Validators.required],
          acronym: [address.acronym],
          street: [address.street],
          number: [address.number],
          stairs: [address.stairs],
          floor: [address.floor],
          door: [address.door],
          town: [address.town],
          postalCode: [address.postalCode],
          province: [address.province],
          codeCountry: [address.codeCountry],
          country: [address.country],
          cadastralReference: [address.cadastralReference],
          endDate: [address.endDate],
          id: [address.id],
          client: [address.client],
          // observations: [address.observations],
        }));
      });
      this.addresses = addressesData.filter(address => address.type === 'ACTIVITY');
      const activitiesData = await this.clientsService.getClientActivities(this.clientId);
      this.activities.clear();
      activitiesData.forEach(activity => {
        activity.startDate = parseDateOnlyToLocal(activity.startDate);
        activity.endDate = parseDateOnlyToLocal(activity.endDate);
        activity.iaeExcemptionStartDate = parseDateOnlyToLocal(activity.iaeExcemptionStartDate);
        activity.iaeExcemptionEndDate = parseDateOnlyToLocal(activity.iaeExcemptionEndDate);
        activity.iaeExcemptionTurnoverStartDate = parseDateOnlyToLocal(activity.iaeExcemptionTurnoverStartDate);
        activity.iaeExcemptionTurnoverEndDate = parseDateOnlyToLocal(activity.iaeExcemptionTurnoverEndDate);
        this.activities.push(this.fb.group({
          type: [activity.type],
          startDate: [activity.startDate, Validators.required],
          endDate: [activity.endDate],
          CNAECode: [activity.CNAECode],
          IAECode: [activity.IAECode],
          isPrincipal: [activity.isPrincipal],
          withLocal: [activity.withLocal],
          town: [activity.town],
          province: [activity.province],
          totalBuilt: [activity.totalBuilt],
          totalUseful: [activity.totalUseful],
          m2WithoutReduction: [activity.m2WithoutReduction],
          m2Uncovered: [activity.m2Uncovered],
          m2Teaching: [activity.m2Teaching],
          m2Store: [activity.m2Store],
          m2CoveredParking: [activity.m2CoveredParking],
          withWorkCenter: [activity.withWorkCenter],
          socialSecurityCode: [activity.socialSecurityCode],
          workCenterCode: [activity.workCenterCode],
          internshipCode: [activity.internshipCode],
          laboralAuthorityNumber: [activity.laboralAuthorityNumber],
          mutua: [activity.mutua],
          colectiveAgreement: [activity.colectiveAgreement],
          srpl: [activity.srpl],
          agreementInsurance: [activity.agreementInsurance],
          legalRepresentation: [activity.legalRepresentation],
          legalRepresentationType: [activity.legalRepresentationType],
          tgssNumber: [activity.tgssNumber],
          healthComittee: [activity.healthComittee],
          equalityPlan: [activity.equalityPlan],
          lismiObligations: [activity.lismiObligations],
          lgtbiProtocol: [activity.lgtbiProtocol],
          complaintsChannel: [activity.complaintsChannel],
          sexualProtocol: [activity.sexualProtocol],
          redSystemNumber: [activity.redSystemNumber],
          socialSecurityRegime: [activity.socialSecurityRegime],
          companyLogo: [activity.companyLogo],
          companySignature: [activity.companySignature],
          payrollIban: [activity.payrollIban],
          socialSecurityIban: [activity.socialSecurityIban],
          accidentsMutua: [activity.accidentsMutua],
          collectiveAgreementApplicable: [activity.collectiveAgreementApplicable],
          numWorkers: [activity.numWorkers],
          powerKw: [activity.powerKw],
          numVehicles: [activity.numVehicles],
          vehicleTypes: [activity.vehicleTypes],
          numMachines: [activity.numMachines],
          machineryTypes: [activity.machineryTypes],
          shopWindows: [activity.shopWindows],
          quotaClass: [activity.quotaClass],
          iaeExcemption: [activity.iaeExcemption],
          iaeExcemptionByStartUp: [activity.iaeExcemptionByStartUp],
          iaeExcemptionByTurnover: [activity.iaeExcemptionByTurnover],
          iaeExcemptionStartDate: [activity.iaeExcemptionStartDate],
          iaeExcemptionEndDate: [activity.iaeExcemptionEndDate],
          iaeExcemptionTurnoverStartDate: [activity.iaeExcemptionTurnoverStartDate],
          iaeExcemptionTurnoverEndDate: [activity.iaeExcemptionTurnoverEndDate],
          clientAddress: [activity.clientAddress?.id ?? null],
          id: [activity.id],
          client: [activity.client],
          observations: [activity.observations ?? ''],
        }));
      });
      this.configActivitiesTable.data = activitiesData;
      await this.loadFieldAuditData();
    }
  }

  async loadFieldAuditData() {
    if (!this.clientId) return;
    try {
      this.fieldAuditData = await this.auditService.getLatestPerField(this.clientId, 'client_activity');
    } catch {
      this.fieldAuditData = {};
    }
  }

  get activities(): FormArray {
    return this.activitiesForm.get('activities') as FormArray;
  }

  get activeTableConfig(): any {
    if (!this.snapshotData) return this.configActivitiesTable;
    return {
      ...this.configActivitiesTable,
      headers: this.configActivitiesTable.headers.filter((h: any) => h.key !== 'delete'),
    };
  }


  addActivity() {
    const activity = this.fb.group({
      type: [''],
      startDate: [null, Validators.required],
      endDate: [null],
      CNAECode: [''],
      IAECode: [''],
      isPrincipal: [false],
      withLocal: [false],
      town: [''],
      province: [''],
      totalBuilt: [null],
      totalUseful: [null],
      m2WithoutReduction: [null],
      m2Uncovered: [null],
      m2Teaching: [null],
      m2Store: [null],
      m2CoveredParking: [null],
      withWorkCenter: [false],
      socialSecurityCode: [''],
      workCenterCode: [''],
      internshipCode: [''],
      laboralAuthorityNumber: [''],
      mutua: [''],
      colectiveAgreement: [''],
      srpl: [''],
      agreementInsurance: [''],
      legalRepresentation: [false],
      legalRepresentationType: [''],
      tgssNumber: [''],
      healthComittee: [false],
      equalityPlan: [false],
      lismiObligations: [false],
      lgtbiProtocol: [false],
      complaintsChannel: [false],
      sexualProtocol: [false],
      redSystemNumber: [''],
      socialSecurityRegime: [''],
      companyLogo: [''],
      companySignature: [''],
      payrollIban: [''],
      socialSecurityIban: [''],
      accidentsMutua: [''],
      collectiveAgreementApplicable: [''],
      numWorkers: [null],
      powerKw: [null],
      numVehicles: [null],
      vehicleTypes: [''],
      numMachines: [null],
      machineryTypes: [''],
      shopWindows: [''],
      quotaClass: [''],
      iaeExcemption: [null],
      iaeExcemptionByStartUp: [false],
      iaeExcemptionByTurnover: [false],
      iaeExcemptionStartDate: [null],
      iaeExcemptionEndDate: [null],
      iaeExcemptionTurnoverStartDate: [null],
      iaeExcemptionTurnoverEndDate: [null],
      clientAddress: [null],
      client: [null],
      observations: [''],
    });

    this.activities.push(activity);
  }

  private toActivityPayload(activity: any) {
    return {
      ...activity,
      startDate: toDateOnlyPayload(activity.startDate),
      endDate: toDateOnlyPayload(activity.endDate),
      iaeExcemptionStartDate: toDateOnlyPayload(activity.iaeExcemptionStartDate),
      iaeExcemptionEndDate: toDateOnlyPayload(activity.iaeExcemptionEndDate),
      iaeExcemptionTurnoverStartDate: toDateOnlyPayload(activity.iaeExcemptionTurnoverStartDate),
      iaeExcemptionTurnoverEndDate: toDateOnlyPayload(activity.iaeExcemptionTurnoverEndDate),
    };
  }

  async save() {
    // Save activities
    for (let i = 0; i < this.activities.length; i++) {
      if (this.activities.at(i).dirty) {
        const activity = this.activities.at(i).value;
        activity.client = Number(this.clientId);
        await this.clientsService.saveClientActivity(this.toActivityPayload(activity));
      }
    }
    await this.getData();
  }


  /** Guarda de envío: un doble clic crearía duplicados. */
  isSubmitting = false;
  /** Último error de guardado o borrado de un modal, para mostrarlo al usuario. */
  submitError = '';

  async saveActivity() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.submitError = '';
    try {
      await this.doSaveActivity();
    } catch (error) {
      console.error(error);
      this.submitError = 'No se pudo guardar. Revisa los datos e inténtalo de nuevo.';
    } finally {
      this.isSubmitting = false;
    }
  }

  /** Los campos de una sección oculta (local sin marcar, exención desactivada...) no se envían con valores viejos. */
  private clearHiddenValues(value: any) {
    if (!value.withLocal) {
      for (const k of ['clientAddress', 'totalBuilt', 'totalUseful', 'm2WithoutReduction', 'm2Uncovered', 'm2Teaching', 'm2Store', 'm2CoveredParking']) {
        value[k] = null;
      }
    }
    if (value.iaeExcemption !== true) {
      value.iaeExcemptionByStartUp = false;
      value.iaeExcemptionByTurnover = false;
    }
    if (!value.iaeExcemptionByStartUp) {
      value.iaeExcemptionStartDate = null;
      value.iaeExcemptionEndDate = null;
    }
    if (!value.iaeExcemptionByTurnover) {
      value.iaeExcemptionTurnoverStartDate = null;
      value.iaeExcemptionTurnoverEndDate = null;
    }
  }

  private async doSaveActivity() {
    if (this.activityForm.invalid) return;
    const value = this.activityForm.value;
    value.client = Number(this.clientId);

    // Asegurar que los campos booleanos no sean null
    value.isPrincipal = value.isPrincipal ?? false;
    value.withLocal = value.withLocal ?? false;
    value.withWorkCenter = value.withWorkCenter ?? false;
    value.legalRepresentation = value.legalRepresentation ?? false;
    value.healthComittee = value.healthComittee ?? false;
    value.equalityPlan = value.equalityPlan ?? false;
    value.lismiObligations = value.lismiObligations ?? false;
    value.lgtbiProtocol = value.lgtbiProtocol ?? false;
    value.complaintsChannel = value.complaintsChannel ?? false;
    value.sexualProtocol = value.sexualProtocol ?? false;
    value.iaeExcemptionByStartUp = value.iaeExcemptionByStartUp ?? false;
    value.iaeExcemptionByTurnover = value.iaeExcemptionByTurnover ?? false;
    this.clearHiddenValues(value);

    let savedActivity;
    if (this.editingActivityIndex !== undefined) {
      const activityGroup = this.activities.at(this.editingActivityIndex);
      activityGroup.patchValue(value);
      savedActivity = await this.clientsService.saveClientActivity(this.toActivityPayload({ ...activityGroup.value, id: value.id }));
    } else {
      savedActivity = await this.clientsService.saveClientActivity(this.toActivityPayload(value));
    }

    // Subir imágenes si hay
    if (savedActivity && savedActivity.id) {
      if (this.companyLogo) {
        await this.clientsService.uploadActivityLogo(this.companyLogo, savedActivity.id);
      }
      if (this.companySignature) {
        await this.clientsService.uploadActivitySignature(this.companySignature, savedActivity.id);
      }
    }

    await this.getData();
    this.closeActivityModal();
  }


  /**
   * Resuelve valor de cuenta bancaria (puede venir como id o como IBAN del backend) al id para el dropdown.
   * Si no está entre las cuentas abiertas (p. ej. ya se dio de baja) se conserva el valor guardado:
   * devolver null lo borraba al guardar la actividad sin que el usuario tocara ese campo.
   */
  private resolveBankAccountValue(value: string | number | null): string | number | null {
    if (value == null || value === '') return null;
    const id = typeof value === 'number' ? value : Number(value);
    if (!Number.isNaN(id) && this.bankAccounts.some((a: any) => a.id === id)) return id;
    const byIban = this.bankAccounts.find((a: any) => a.iban === value || (a.iban && a.iban.replace(/\s/g, '') === String(value).replace(/\s/g, '')));
    return byIban ? byIban.id : value;
  }

  openActivityModal(index?: number) {
    this.submitError = '';
    this.editingActivityIndex = index;
    if (index !== undefined) {
      // In snapshot mode, read from snapshotData directly; otherwise use the FormArray
      const activity = this.snapshotData
        ? this.snapshotData[index]
        : this.activities.at(index).value;

      this.activityForm.patchValue(activity);

      // Resolver campos de cuenta bancaria por si el backend devuelve IBAN en lugar de id
      this.activityForm.patchValue({
        payrollIban: this.resolveBankAccountValue(activity.payrollIban),
        socialSecurityIban: this.resolveBankAccountValue(activity.socialSecurityIban),
      }, { emitEvent: false });

      // Filtrar códigos IAE según el tipo de actividad
      if (activity.type) {
        this.filterIaeCodesByType(activity.type);
      } else {
        this.iaeCodesFiltered = this.iaeCodesGrouped;
      }

      // Cargar previsualizaciones de imágenes si existen
      if (activity.companyLogo) {
        this.companyLogoPreview = this.buildImageUrl(activity.companyLogo);
      } else {
        this.companyLogoPreview = null;
      }

      if (activity.companySignature) {
        this.companySignaturePreview = this.buildImageUrl(activity.companySignature);
      } else {
        this.companySignaturePreview = null;
      }
    } else {
      this.activityForm.reset({
        isPrincipal: false,
        withLocal: false,
        withWorkCenter: false,
        legalRepresentation: false,
        healthComittee: false,
        equalityPlan: false,
        lismiObligations: false,
        lgtbiProtocol: false,
        complaintsChannel: false,
        sexualProtocol: false,
        iaeExcemption: null,
        iaeExcemptionByStartUp: false,
        iaeExcemptionByTurnover: false
      });
      this.companyLogoPreview = null;
      this.companySignaturePreview = null;
      this.iaeCodesFiltered = this.iaeCodesGrouped;
    }

    // En modo snapshot el formulario es de sólo lectura
    if (this.snapshotData) {
      this.activityForm.disable({ emitEvent: false });
    } else {
      this.activityForm.enable({ emitEvent: false });
    }

    // Limpiar archivos seleccionados
    this.companyLogo = null;
    this.companySignature = null;

    this.isActivityModalVisible = true;
  }

  closeActivityModal() {
    this.submitError = '';
    this.isActivityModalVisible = false;
    this.editingActivityIndex = undefined;
    this.activityForm.reset();
    this.activityForm.enable({ emitEvent: false });
    this.companyLogoPreview = null;
    this.companySignaturePreview = null;
    this.companyLogo = null;
    this.companySignature = null;
    this.iaeCodesFiltered = this.iaeCodesGrouped;
  }

  async confirmDeleteActivity() {
    this.submitError = '';
    try {
      await this.doConfirmDeleteActivity();
    } catch (error) {
      console.error(error);
      this.submitError = 'No se pudo eliminar. Inténtalo de nuevo.';
    }
  }

  private async doConfirmDeleteActivity() {
    const activity = this.activities.at(this.deleteActivityIndex).value;
    if (activity.id) {
      await this.clientsService.deleteClientActivity(activity.id);
      await this.getData();
    }
    this.deleteActivityIndex = undefined;
    this.isDeleteActivityModalVisible = false;
  }

  async openDeleteActivityModal(index: number) {
    this.submitError = '';
    this.deleteActivityIndex = index;
    this.isDeleteActivityModalVisible = true;
  }

  closeDeleteActivityModal() {
    this.submitError = '';
    this.deleteActivityIndex = undefined;
    this.isDeleteActivityModalVisible = false;
  }

  onLogoSelect(event: any) {
    const file = event.currentFiles[0];
    if (file) {
      this.companyLogo = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.companyLogoPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onRemoveLogo() {
    this.companyLogo = null;
    this.companyLogoPreview = null;
  }

  onSignatureSelect(event: any) {
    const file = event.currentFiles[0];
    if (file) {
      this.companySignature = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.companySignaturePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onRemoveSignature() {
    this.companySignature = null;
    this.companySignaturePreview = null;
  }

  choose(event: any, callback: any) {
    callback();
  }

  private buildImageUrl(url: string): string {
    if (!url) return null;

    // Si ya es una URL completa (http:// o https://), devolverla tal cual
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }

    // Si es una ruta relativa, construir la URL completa con el base URL del API
    const cleanUrl = url.startsWith('/api/') ? url.substring(5) : url.startsWith('/') ? url.substring(1) : url;
    return `${environment.apiUrl}/${cleanUrl}`;
  }

}
